import { render, staticRenderFns } from "./CommonAnswerList.vue?vue&type=template&id=88cbb5d0&scoped=true"
import script from "./CommonAnswerList.vue?vue&type=script&lang=js"
export * from "./CommonAnswerList.vue?vue&type=script&lang=js"
import style0 from "./CommonAnswerList.vue?vue&type=style&index=0&id=88cbb5d0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88cbb5d0",
  null
  
)

export default component.exports